// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d7f2f8c","453":"2793cba1","732":"9edd22a4"}[chunkId] + ".chunk.js";
};